import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as GiIcons from 'react-icons/gi';
import SafeIcon from '../common/SafeIcon';

const {FiStar,FiSend}=FiIcons;
const {GiDiamondRing,GiRing,GiLinkedRings}=GiIcons;

const ConclusionSection=({t})=> {
  const [isSubscribed,setIsSubscribed]=useState(false);
  // WordPress site URL - Replace with your actual WordPress site URL
  const wordpressSiteUrl='https://www.diamond-shiraishi.hk/';
  // Construct the form URL using WordPress REST API or direct form page
  const formUrl=`${wordpressSiteUrl}/form-embed/`;

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-7xl font-bold mb-8 bg-gradient-to-r from-yellow-400 via-pantone-blue to-blue-600 bg-clip-text text-transparent">
            {t('conclusionTitle')}
          </h1>
          <p className="text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            {t('conclusionDescription')}
          </p>
        </motion.div>

        {/* Action Cards - Reduced to 3 columns */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* Shop Now - Engagement Rings */}
          <a href="https://www.diamond-shiraishi.hk/engagementring%E6%B1%82%E5%A9%9A%E6%88%92%E6%8C%87" target="_blank" rel="noopener noreferrer">
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.2}}
              whileHover={{scale: 1.05}}
              className="group bg-gradient-to-br from-pantone-blue/20 to-blue-600/20 backdrop-blur-sm border border-pantone-blue/20 rounded-2xl p-8 cursor-pointer hover:bg-gradient-to-br hover:from-pantone-blue/30 hover:to-blue-600/30 transition-all duration-300 h-full flex flex-col justify-between"
            >
              <div>
                <div className="bg-gradient-to-r from-pantone-blue to-blue-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform">
                  <SafeIcon icon={GiDiamondRing} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 text-center">{t('exploreCollection')}</h3>
                <p className="text-gray-300 text-center mb-6">
                  {t('browseSelection')}
                </p>
              </div>
              <div className="text-center">
                <span className="inline-flex items-center text-pantone-blue font-semibold group-hover:text-blue-300">
                  {t('shopNow')}
                  <SafeIcon icon={FiStar} className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </motion.div>
          </a>

          {/* Schedule Consultation - Wedding Rings */}
          <a href="https://www.diamond-shiraishi.hk/weddingring%E7%B5%90%E5%A9%9A%E6%88%92%E6%8C%87" target="_blank" rel="noopener noreferrer">
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.4}}
              whileHover={{scale: 1.05}}
              className="group bg-gradient-to-br from-emerald-600/20 to-teal-600/20 backdrop-blur-sm border border-emerald-500/20 rounded-2xl p-8 cursor-pointer hover:bg-gradient-to-br hover:from-emerald-600/30 hover:to-teal-600/30 transition-all duration-300 h-full flex flex-col justify-between"
            >
              <div>
                <div className="bg-gradient-to-r from-emerald-500 to-teal-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform">
                  <SafeIcon icon={GiRing} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 text-center">{t('bookConsultation')}</h3>
                <p className="text-gray-300 text-center mb-6">
                  {t('meetExperts')}
                </p>
              </div>
              <div className="text-center">
                <span className="inline-flex items-center text-emerald-400 font-semibold group-hover:text-emerald-300">
                  {t('scheduleNow')}
                  <SafeIcon icon={FiStar} className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </motion.div>
          </a>

          {/* Custom Design - Matching Sets */}
          <a href="https://www.diamond-shiraishi.hk/set_ring_collection/" target="_blank" rel="noopener noreferrer">
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.6}}
              whileHover={{scale: 1.05}}
              className="group bg-gradient-to-br from-rose-600/20 to-pink-600/20 backdrop-blur-sm border border-rose-500/20 rounded-2xl p-8 cursor-pointer hover:bg-gradient-to-br hover:from-rose-600/30 hover:to-pink-600/30 transition-all duration-300 h-full flex flex-col justify-between"
            >
              <div>
                <div className="bg-gradient-to-r from-rose-500 to-pink-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform">
                  <SafeIcon icon={GiLinkedRings} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 text-center">{t('customDesign')}</h3>
                <p className="text-gray-300 text-center mb-6">
                  {t('createUnique')}
                </p>
              </div>
              <div className="text-center">
                <span className="inline-flex items-center text-rose-400 font-semibold group-hover:text-rose-300">
                  {t('startDesigning')}
                  <SafeIcon icon={FiStar} className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </motion.div>
          </a>
        </div>

        {/* Fluent Form Embed Section */}
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 0.8}}
          className="grid lg:grid-cols-1 gap-12 mb-16"
        >
          <div className="bg-gradient-to-br from-pantone-blue/20 to-purple-600/20 backdrop-blur-sm border border-pantone-blue/20 rounded-2xl p-8">
            <div className="text-center mb-8">
              <SafeIcon icon={FiSend} className="w-12 h-12 text-pantone-blue/80 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-white mb-2">Get Started with Your Diamond Journey</h3>
              <p className="text-gray-300">Fill out the form below and our diamond experts will contact you shortly.</p>
            </div>

            {/* Iframe Embed - Responsive height for mobile */}
            <div className="w-full bg-white/5 rounded-xl overflow-hidden">
              <iframe 
                src={formUrl} 
                className="w-full border-0 rounded-xl"
                title="Diamond Inquiry Form"
                style={{
                  background: 'transparent',
                  minHeight: '1800px',
                  height: '1800px'
                }}
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </motion.div>

        {/* Final Message */}
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 1}}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-purple-600/20 to-pantone-blue/20 backdrop-blur-sm border border-purple-500/20 rounded-2xl p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-6">{t('thankYouJoining')}</h3>
            <p className="text-xl text-gray-300 leading-relaxed mb-8">
              {t('finalMessage')}
            </p>
            <div className="flex justify-center">
              <motion.div
                animate={{rotate: 360,scale: [1,1.1,1]}}
                transition={{rotate: {duration: 20,repeat: Infinity,ease: "linear"},scale: {duration: 2,repeat: Infinity}}
}
                className="relative"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-white via-pantone-blue/30 to-purple-300 rounded-lg blur-xl opacity-60"></div>
                <img 
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758784431723-princess-diamond-transparent.png" 
                  alt="Diamond" 
                  className="w-20 h-20 object-contain relative z-10 drop-shadow-2xl"
                  style={{
                    filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.8)) brightness(1.3) contrast(1.2)',
                  }}
                />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ConclusionSection;